// ##### 24-09-09 Komarov
import axios from 'axios';
// ##### Komarov 2025-07-22
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-01-22 Komarov
import moment from 'moment';
import {
  getGeneralGeo,
  getPickedCurrencyResponse,
} from '../../../../../Redux/actions';
// ##### 25-05-21 Komarov
import LoadingMessage from '../../../../Library/PageDevices/LoadingMessage';
import { useWindowWidthAndHeight } from '../../../Helpers/WindowResizeHook';
// ##### 23-11-02 Komarov
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import UlTag from './UlTag';
// ##### 25-01-14 Komarov
import { getPostObject } from '../../../../../helpers/crypto';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../../server/helpers/uniLog';
// ##### 25-05-10 Komarov
import useValidateQuery from '../../../../../helpers/useValidateQuery';

// ##### Komarov 2025-07-14
const GuestItem = () => {
  const language = useSelector(state => state.language);
  useEffect(() => {
    moment.locale(language);
  }, [language]);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // ##### 23-11-22 Komarov
  // let history = useHistory();
  // ##### 23-12-27 Komarov
  const locale = useSelector(state => state.language);
  // ##### 25-05-10 Komarov
  const search_data = useValidateQuery();

  const dispatch = useDispatch();
  // ##### 24-07-25 Komarov
  const generalGeo = useSelector(state => state.cities.gen_locs);

  // ##### 23-11-22 Komarov
  // const [rate, setRate] = useState([])
  const [rate, setRate] = useState(undefined);
  const [smartResultFound, setSmartResultFound] = useState(false);

  // console.log('[TEST]', test)

  ///получаю из смарта тур имя, тур айди, сити имя, сити айди
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/SecondPageofSearchModule/Tours/GuestItem.js:getGeneralGeo()'
    );
    // ##### 24-07-25 Komarov
    // dispatch (getGeneralGeo (locale));
    generalGeo.length > 0 || dispatch(getGeneralGeo(locale));
    // ##### Komarov 2025-07-21
    dispatch(getPickedCurrencyResponse(search_data?.selected_currency));
    // ##### 23-04-12 Komarov
  }, [dispatch, locale, search_data?.selected_currency]);

  // console.log('[GENERAL_GEO] , ' , generalGeo)///получаю из смарта тур имя, тур айди, сити имя, сити айди
  // ##### 23-03-29 Komarov
  const [width /* height */] = useWindowWidthAndHeight();

  ///используется непосредственно для вывода названий туров на странице.
  ///если айди города, который мне приходит первоначально от Саши Ефица (классификатор contracts) не находится в данных, пришедших в результате поиска клиентом,
  ///то в переменную filtered возвращается тур айди из классификатора contracts, равное айди, пришедшему от клиентского поиска
  ///иначе возвращается сити айди из классификатора contracts, равное айди из поиска

  // ##### 24-03-21 Komarov
  const filtered = generalGeo.filter(item => {
    if (parseInt(item.city_id) === parseInt(search_data?.id)) {
      return parseInt(item.city_id);
    }
    return parseInt(item.tour_id) === parseInt(search_data?.id);
  });

  ///отфильтровала данные поиска, чтобы получить только тур айди поиска
  // ##### 24-03-21 Komarov
  const filtered_tour_id = filtered.map(item1 => item1.tour_id);

  const currentMonth = moment().format('YYYY-MM');
  const today = moment().format('YYYY-MM-DD');

  const { user: currentUser } = useSelector(state => state.auth);
  // ##### 24-03-01 Komarov
  const company_cipher = useSelector(state => state.whitelabel.company_cipher);

  // ##### Komarov 2025-07-12
  useEffect(() => {
    const data = {
      // ##### 25-02-12 Komarov
      company_cipher: company_cipher || '',
      city_id: search_data?.city_id,
      date:
        currentMonth === search_data?.date ? today : `${search_data.date}-01`,
      window: 30,
      tour_id: filtered_tour_id.length === 1 ? filtered_tour_id[0] : null, ///если в ответ при поиске пришёл массив из более 1 айди тура (что может быть при поиске клиентом по городу, а не по туру), то, так как Смарт не принимает массив, данный параметр при передаче данных игнорируется (равен null). Иначе этот параметр в одном экземпляре и он тогда передаётся в Смарт и участвует в фильтрации
    };

    const postObject = getPostObject({
      action: 'GetPriceTourRQ',
      user_id: currentUser.user_id,
      refpartner: currentUser.company_id,
      language: locale,
      data,
    });

    !rate &&
      axios
        .post(postObject.url, postObject.parameters)
        // axios.post('http://smartbooker/interface/xmlsubj/', JSON.stringify({ActionRQ}))
        // ##### 24-11-01 Komarov
        .then(async res => {
          if ((await res.data.length) === 0) {
            // ##### 23-11-22 Komarov TODO: Переделать код: изменить это значение, начиная со Смарта, чтобы в случае отсутствия результатов в выборке из БД возвращался результат более информативный (например, found: false). И такое же значение обрабатывать и использовать в коде сайта
            setSmartResultFound('Nothing found');
          }
          setRate(await res.data);
        })
        .catch(error => {
          setRate(undefined);
          // ##### 25-04-30 Komarov
          console.error('[axios error] : ', error);
        });
    // ##### 23-04-12 Komarov
  }, [
    currentUser.user_id,
    search_data?.city_id,
    currentMonth,
    search_data?.date,
    filtered_tour_id,
    today,
    // ##### 24-03-21 Komarov
    rate,
    filtered_tour_id[0],
  ]);

  // ##### Komarov 2025-08-05
  const SearchResults = useSelector(state => state.pagesRedux[state.language]?.SearchResults || '');

  return (
    <div className="TourSearchrendering_Wrapper" data-component="GuestItem">
      <div>
        <h3
          style={{
            marginTop: '2vw',
            color: '#003057',
            fontFamily: 'Arial',
            fontSize: '30px',
            fontWeight: 'bold',
          }}
        >
          {
            // ##### 23-10-04 Komarov
            SearchResults
          }
        </h3>
      </div>

      <div>
        {
          // ##### 23-11-22 Komarov
          // !rate || rate.length === 0 ?
          !rate ? (
            <div>
              <LoadingMessage loadingMessageClass="RateLoading" />
            </div>
          ) : // ##### 23-11-22 Komarov
            rate.length === 0 ? (
              <LoadingMessage
                loadingMessageClass="RateLoading"
                smartResultFound={smartResultFound}
              />
            ) : (
              // ##### 23-03-01 Komarov
              <>
                {/* ##### 23-11-02 Komarov */}
                <Media greaterThanOrEqual="Laptop-1024-1440">
                  <UlTag
                    // ulCLassName='greaterThan-desktopMinWidth_1024 TourDescriptionUl'
                    ulCLassName="TourDescriptionUl"
                    width={width * 0.65}
                    // divClassName='greaterThan-desktopMinWidth_1024 TourDescriptionContent'
                    divClassName="TourDescriptionContent"
                    filtered={filtered}
                    rate={rate}
                  />
                </Media>
                {/* ##### 23-04-20 Komarov */}
                <Media lessThan="Laptop-1024-1440">
                  <UlTag
                    // ulCLassName='lessThanOrEqual-desktopMinWidth_1024 TourDescriptionUlSmallScreen'
                    ulCLassName="TourDescriptionUlSmallScreen"
                    width={width * 0.9}
                    // divClassName='lessThanOrEqual-desktopMinWidth_1024 TourDescriptionContentSmallScreen'
                    divClassName="TourDescriptionContentSmallScreen"
                    filtered={filtered}
                    rate={rate}
                  />
                </Media>
              </>
            )
        }
      </div>
    </div>
  );
};

export default GuestItem;
